import { i18n } from "@tellescope/i18n";
import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Label,
} from "@tellescope/ui";
import { Check, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

const DEFAULT_INTERVAL_OPTIONS = [5, 10, 15, 20, 30, 45, 60];

export interface IntervalSelectorProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  className?: string;
  label: string;
  defaultValue?: string;
  intervals?: number[];
  disabled?: boolean;
}

export const IntervalSelector = ({
  value,
  onChange,
  className,
  label,
  defaultValue = i18n.t("Default", { ns: "calendar" }),
  intervals = DEFAULT_INTERVAL_OPTIONS,
  disabled,
}: IntervalSelectorProps) => {
  const { t } = useTranslation("calendar");

  return (
    <div className={cn("space-y-1", className)}>
      <Label className="text-muted-foreground text-xs font-light">{label}</Label>
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={disabled}>
          <Button
            variant="outline"
            size="sm"
            className="h-auto text-xs md:text-xs py-1 grow justify-between w-full font-light"
            disabled={disabled}
          >
            {value !== undefined ? t("{{amount}} min", { amount: value }) : defaultValue}
            <ChevronDown />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onClick={() => onChange(undefined)}>
            {defaultValue}
            {value === undefined && <Check />}
          </DropdownMenuItem>
          {intervals.map((amount) => (
            <DropdownMenuItem key={amount} onClick={() => onChange(amount)}>
              {t("{{amount}} min", { amount })}
              {value === amount && <Check />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
